import { and, or, helpers, maxLength, minLength, required } from '@vuelidate/validators'

function commonString(message) {
  return {
    required: helpers.withMessage(message, required),
  }
}

export function commonCompanyName() {
  return commonString($t('Please enter your business name'))
}

export function commonCompanyNumber() {
  return commonString($t('Please enter your business number'))
}

export function auBusinessNumber() {
  return {
    length: helpers.withMessage(
      $t('Please enter a valid Australian Business Number (ABN)'),
      or(and(minLength(11), maxLength(11)), and(minLength(14), maxLength(14))),
    ),
  }
}

export function deTaxNumber() {
  return {
    minLength: helpers.withMessage(
      $t('Please enter a valid German tax number or VAT number'),
      minLength(9),
    ),
    maxLength: helpers.withMessage(
      $t('Please enter a valid German tax number or VAT number'),
      maxLength(14),
    ),
    required: helpers.withMessage(
      $t('Please enter your German tax number or VAT number'),
      required,
    ),
  }
}
export function sgCompanyNumber() {
  return {
    required,
    minLength: minLength(9),
    maxLength: maxLength(10),
  }
}
